import { render, staticRenderFns } from "./app-detail-wiki-guide-btn.vue?vue&type=template&id=c16f1574&"
import script from "./app-detail-wiki-guide-btn.vue?vue&type=script&lang=js&"
export * from "./app-detail-wiki-guide-btn.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-wiki-guide-btn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports